import { SVGProps, Ref, forwardRef } from 'react';

export const SafeFilledSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M8.5 0c3.287 0 4.93 0 6.037.908q.305.25.555.555C16 2.569 16 4.213 16 7.5s0 4.93-.908 6.037a4 4 0 0 1-.555.555 3.2 3.2 0 0 1-1.205.605c0 .609-.002.916-.194 1.108C12.942 16 12.628 16 12 16h-.667c-.628 0-.943 0-1.138-.195-.158-.158-.187-.394-.193-.812Q9.315 15 8.5 15h-1q-.815 0-1.503-.006c-.006.417-.034.653-.192.81-.196.196-.51.196-1.138.196H4c-.628 0-.942 0-1.138-.195-.192-.192-.195-.5-.195-1.109a3.4 3.4 0 0 1-.99-.444l-.214-.16a4 4 0 0 1-.427-.405l-.128-.15C0 12.431 0 10.787 0 7.5c0-3.082 0-4.719.748-5.823l.16-.214q.187-.228.405-.427l.15-.128C2.569 0 4.213 0 7.5 0zM5 4.5a2 2 0 0 0-1.122 3.656L3 10.5h4l-.879-2.344A2 2 0 0 0 5 4.5m4 3.7h4V6.8H9z"
                fill="currentColor"
            />
        </g>
    </svg>
));
SafeFilledSize16Glyph.displayName = 'SafeFilledSize16Glyph';
